import React , {Component} from 'react';
import star from './../images/star.svg';
import {
    Link
} from 'framework7-react';
class BranchCard extends Component{
    render(){
        const { object , category } = this.props
        let maxBranchDiscount = 0
        object.discounts.map((item , index)=> {
            if (parseInt(item.percent_branchs) > maxBranchDiscount)
            {
                maxBranchDiscount = parseInt(item.percent_branchs)
            }
            if (parseInt(item.percent_app) > maxBranchDiscount)
            {
                maxBranchDiscount = parseInt(item.percent_app)
            }
        })
        let sh = "d-block"
        if (category !== "همه رستوران ها")
        {
            sh = "d-none"
            object.categories.map((item , index) => {
                if (item['title_fa'] === category )
                {
                    sh = "d-block"
                }
            })
        }
        return(
            <div className={sh}>
                {

                    object.test_mode === false || true ? (
                        <Link className="branch" href={`/branch/${ object.ID}/`}>
                            <div className="row no-gutters">
                                <div className="col-25">
                                    <div className={object.active ? `img-container active` : `img-container offline`}>
                                        <img src={object.imgurl} />
                                    </div>
                                </div>
                                <div className="col-75">
                                    <div className="details">
                                        <div className="title">
                                            { object.title_fa }
                                        </div>
                                        <div className="meta">
                                            <div className="rate">
                                                { object.rate }
                                                <img src={star}/>
                                            </div>
                                            <div className="rate-count">
                                                ( { object.rate_count } )
                                            </div>
                                            <div className="category">
                                                {
                                                    object.categories.map((item , index)=><span key={index}> {item['title_fa']} </span>)
                                                }
                                            </div>
                                        </div>
                                        <div className="address">
                                            {/*{ object.categories.map((item , index)=>(
                                                <span key={index}>
                                                    {index > 0 ? (" , ") : (``)}
                                                    {item['title_fa']}

                                                </span>
                                            )) }*/}
                                            {object.address}
                                        </div>

                                        { maxBranchDiscount > 0 ? (
                                            <div className="discount">
                                                <span>{maxBranchDiscount} %</span>
                                            </div>
                                        ): (
                                            <span className="d-none"></span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ):(
                        <div>

                        </div>
                    )
                }
            </div>

        )
    }
}

export default BranchCard;